import { createAction, props } from "@ngrx/store";
import { LearningPlanActionTypes } from "src/app/constants/StoreConstants";
import { LearningPlan } from "src/app/_models/LearningPlan";
import { SkillsCheckContent } from "src/app/_models/SkillsCheck";
import { LearningPlanActivity } from "src/app/_models/LearningPlanActivity";
import { HttpErrorResponse } from "@angular/common/http";
import { LearningPlanEdit, LearningPlanEditByCategoryResult } from "src/app/_models/LearningPlanEdit";
import { SaveManualLearningPlanDto } from "src/app/_models/SaveManualLearningPlanDto";
import { ManualLearningPlanResultDto } from "src/app/_models/ManualLearningPlanResultDto";

export const SetSelectedCourse = createAction(
	LearningPlanActionTypes.SetSelectedCourse,
	props<{courseId: number}>()
);

export const SetPanelState = createAction(
	LearningPlanActionTypes.SetPanelState,
  props<{state: LearningPlan[], courseId: number}>()
);

export const UpdatePanelState = createAction(
	LearningPlanActionTypes.UpdatePanelState,
  props<{ topicId: number}>()
);

export const UpdatePanelStateSuccess = createAction(
	LearningPlanActionTypes.UpdatePanelStateSuccess
);

export const SetSelectedCourseSuccess = createAction(
	LearningPlanActionTypes.SetSelectedCourseSuccess
);

export const SetPanelStateSuccess = createAction(
	LearningPlanActionTypes.SetPanelStateSuccess
);

export const SetAllowPopUp = createAction(
	LearningPlanActionTypes.UpdateAllowPopUpStart,
	props<{allowPopUp: boolean}>()
);

export const SetAllowPopUpSuccess = createAction(
	LearningPlanActionTypes.UpdateAllowPopUpSuccess
);

export const UpdatePopUpReminder = createAction(
	LearningPlanActionTypes.UpdatePopUpReminder,
	props<{learnerLearningObjectIds: number[]}>()
);

export const GetLearningPlan = createAction(
	LearningPlanActionTypes.GetLearningPlan,
	props<{courseId: number}>()
);

export const GetLearningPlanSuccess = createAction(
	LearningPlanActionTypes.GetLearningPlanSuccess,
	props<{result: LearningPlan[]}>()
);

export const GetLearningPlanError = createAction(
	LearningPlanActionTypes.GetLearningPlanError,
	props<{error: any}>()
);

export const GetManualLearningPlan = createAction(
	LearningPlanActionTypes.GetManualLearningPlan,
	props<{learnerId: number, courseId: number}>()
);

export const GetManualLearningPlanSuccess = createAction(
	LearningPlanActionTypes.GetManualLearningPlanSuccess,
	props<{result: ManualLearningPlanResultDto[]}>()
);

export const GetManualLearningPlanError = createAction(
	LearningPlanActionTypes.GetManualLearningPlanError,
	props<{error: any}>()
);

export const SaveManualLearningPlan = createAction(
	LearningPlanActionTypes.SaveManualLearningPlan,
	props<{param: SaveManualLearningPlanDto[]}>()
);

export const SaveManualLearningPlanSuccess = createAction(
	LearningPlanActionTypes.SaveManualLearningPlanSuccess,
	props<{result: boolean}>()
);

export const SaveManualLearningPlanError = createAction(
	LearningPlanActionTypes.SaveManualLearningPlanError,
	props<{error: any}>()
);

export const AssignSkillsCheckContent = createAction(
	LearningPlanActionTypes.AssignSkillsCheckContent,
	props<{skillsCheckContent: SkillsCheckContent, courseId: number}>()
);

export const AssignSkillsCheckContentSuccess = createAction(
	LearningPlanActionTypes.AssignSkillsCheckContentSuccess,
	props<{courseId: number}>()
);

export const AssignSkillsCheckContentError = createAction(
	LearningPlanActionTypes.AssignSkillsCheckContentError,
	props<{error: any}>()
);

export const SetActiveActivity = createAction(
	LearningPlanActionTypes.SetActiveActivity,
	props<{activity: LearningPlanActivity}>()
);

export const GetLearnerLearningPlan = createAction(
	LearningPlanActionTypes.GetLearnerLearningPlan,
	props<{learnerId: number, courseId: number}>()
);

export const GetLearnerLearningPlanSuccess = createAction(
	LearningPlanActionTypes.GetLearnerLearningPlanSuccess,
	props<{result: LearningPlan[]}>()
);

export const GetLearnerLearningPlanError = createAction(
	LearningPlanActionTypes.GetLearnerLearningPlanError,
	props<{error: HttpErrorResponse}>()
);

export const ResetLearningPlan = createAction(
	LearningPlanActionTypes.ResetLearingPlan
);

export const GenerateLearningPlan = createAction(
	LearningPlanActionTypes.GenerateLearningPlan,
	props<{dto: LearningPlanEdit}>()
);

export const EditLearningPlan = createAction(
	LearningPlanActionTypes.EditLearningPlan,
	props<{dto: LearningPlanEdit}>()
);

export const EditLearningPlanSuccess = createAction(
	LearningPlanActionTypes.EditLearningPlanSuccess,
	props<{result: boolean}>()
);

export const EditLearningPlanError = createAction(
	LearningPlanActionTypes.EditLearningPlanError,
	props<{error: HttpErrorResponse}>()
);

export const ResetEditLearningPlan = createAction(
	LearningPlanActionTypes.ResetEditLearingPlan
);

export const UpdateWrittenAssignment = createAction(
  LearningPlanActionTypes.UpdateWrittenAssignment,
  props<{ topicId: number, writtenAssignment: string }>()
);

export const UpdateCategoryOnCurrentLevelChange = createAction(
  LearningPlanActionTypes.UpdateCategoryOnCurrentLevelChange,
  props<{ topicId: number, courseId: number, categoryCode: string, level: string, learnerId: number }>()
);

export const GetCategoryOnCurrentLevelChangeSuccess = createAction(
  LearningPlanActionTypes.GetCategoryOnCurrentLevelChangeSuccess,
	props<{result: LearningPlanEditByCategoryResult}>()
);